import { render, staticRenderFns } from "./ErrorStep.component.vue?vue&type=template&id=a65b9d7a"
import script from "./ErrorStep.component.vue?vue&type=script&lang=js"
export * from "./ErrorStep.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports